import { combineReducers } from 'redux';
import { documents } from './Documents/redux/reducers/documents';
import { filters } from './Documents/redux/reducers/filters';
import { docCard } from './DocumentsCard/redux/reducers';
import { contractSettings } from './ContractSettings/redux/reducers/contractSettings';

export const Documents = combineReducers({
  documents,
  filters,
  docCard,
  contractSettings,
});
